export default () => value => {
  if (/\s/.test(value)) return 'ra.validation.noSpaces'
  if (/_/.test(value)) return 'ra.validation.noUnderscores'
  return undefined
}
